import script from "./pcCustom.vue?vue&type=script&setup=true&lang=ts"
export * from "./pcCustom.vue?vue&type=script&setup=true&lang=ts"

import "./pcCustom.vue?vue&type=style&index=0&id=6103bbd5&lang=less"

const __exports__ = script;

export default __exports__